import { generateCustomId } from "./generate-custom-id.js";
import { TreeNodeChildren } from "./tree-node-children.js";
export class TreeNode {
    constructor(data, parentId) {
        var _a;
        this._children = new TreeNodeChildren();
        this._parentNodeId = undefined;
        this._id = (data === null || data === void 0 ? void 0 : data.id) || generateCustomId();
        this._value = data === null || data === void 0 ? void 0 : data.value;
        this._parentNodeId = parentId || undefined;
        const childrenNodes = (_a = data === null || data === void 0 ? void 0 : data.children) === null || _a === void 0 ? void 0 : _a.map((n) => new TreeNode(n, this._id));
        this._children = new TreeNodeChildren(childrenNodes);
    }
    _getRawNode() {
        let r = {
            id: this._id,
            value: this._value,
        };
        const children = this.getChildrenRawNodes();
        if ((children === null || children === void 0 ? void 0 : children.length) > 0)
            r["children"] = children;
        return r;
    }
    getChildrenRawNodes() {
        var _a;
        return (_a = this._children) === null || _a === void 0 ? void 0 : _a.values();
    }
    value() {
        return this._getRawNode();
    }
    id() {
        return this._id;
    }
    update(update) {
        if (typeof this._value === "string" ||
            typeof this._value === "number" ||
            typeof this._value === "boolean") {
            this._value = update;
        }
        if (typeof this._value === "object") {
            this._value = Object.assign(Object.assign({}, this._value), update);
        }
        return this;
    }
    children() {
        return this._children.getNodes();
    }
    getChildrenValues() {
        return this._children.values();
    }
    getChildrenIds() {
        return this.children().map((i) => i.id());
    }
    add(node) {
        this._children.add(node, this._id);
    }
    remove(id) {
        this._children.remove(id);
    }
    find(id) {
        if (this.id() === id)
            return this;
        let foundNode = undefined;
        const children = this.children();
        for (let i = 0; i < children.length; i++) {
            const child = children[i];
            foundNode = child.find(id);
            if (foundNode)
                return foundNode;
        }
        return foundNode;
    }
    getParentId() {
        return this._parentNodeId;
    }
    isRoot() {
        return !this._parentNodeId;
    }
    isLeaf() {
        var _a;
        return !this.children() || ((_a = this.children()) === null || _a === void 0 ? void 0 : _a.length) === 0;
    }
}
//# sourceMappingURL=tree-node.js.map